<template>
  <div class="enrolling-exam-write-pass-student">
    <PlatDataGridSiteUnit grid-id="PeEnrollExamWritePassStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingExamWritePassStudent',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
  .enrolling-exam-write-pass-student {
    height: 100%;
  }
</style>
